import {ServiceTypeSelectorProps, serviceTypesSelector, useGetAllServiceTypesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseServiceTypeMultiSelect, BaseServiceTypeMultiSelectProps} from "./BaseServiceTypeMultiSelect";

export type ServiceTypeMultiSelectProps = Omit<BaseServiceTypeMultiSelectProps, "entities" | "loading"> & {
  selector?: ServiceTypeSelectorProps
}

export const ServiceTypeMultiSelect = (props: ServiceTypeMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectServiceTypes = useMemo(() => {
    return serviceTypesSelector();
  }, []);

  const {serviceTypes, isLoading} = useGetAllServiceTypesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      serviceTypes: selectServiceTypes(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseServiceTypeMultiSelect entities={serviceTypes} loading={isLoading} {...rest} />;
};
